import { configQuery, getFeatureEnabled } from '@gig/magic-common';
import { Feature } from '@gig/magic-messages';

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
class AlternateLinkService {
  constructor() {
    this.baseUrl = "";
    this.hreflang = "";
  }
  setAlternateTag(url, options) {
    this.isEnabled().then((enabled) => {
      if (!enabled) {
        return;
      }
      const tag = this.queryOrCreateTag();
      tag.setAttribute("rel", "alternate");
      tag.setAttribute("hreflang", this.hreflang);
      tag.setAttribute("data-v-test-id", "alternate-tag");
      const href = options.useBaseUrl ? this.concatBaseUrl(url) : url;
      tag.setAttribute("href", href);
    });
  }
  destroyAlternateTag() {
    this.isEnabled().then((enabled) => {
      if (!enabled) {
        return;
      }
      const tag = this.queryTag();
      if (tag) {
        tag.remove();
      }
    });
  }
  concatBaseUrl(url) {
    if (url.startsWith("/")) {
      url = url.substring(1);
    }
    if (this.baseUrl.endsWith("/")) {
      return this.baseUrl + url;
    }
    return this.baseUrl + "/" + url;
  }
  isEnabled() {
    return __async(this, null, function* () {
      const enabled = yield getFeatureEnabled(Feature.HREFLANG_ON_PAGE);
      if (!enabled) {
        return false;
      }
      yield this.queryConfig();
      if (!this.baseUrl || !this.hreflang) {
        return false;
      }
      return true;
    });
  }
  queryOrCreateTag() {
    const tag = this.queryTag();
    if (tag) {
      return tag;
    }
    const createdTag = document.createElement("link");
    document.head.appendChild(createdTag);
    return createdTag;
  }
  queryTag() {
    return document.querySelector(`link[rel=alternate]`);
  }
  queryConfig() {
    return __async(this, null, function* () {
      var _a, _b;
      const config = yield configQuery("seo");
      if (!((_a = config == null ? void 0 : config.alternateLink) == null ? void 0 : _a.baseUrl) || !((_b = config == null ? void 0 : config.alternateLink) == null ? void 0 : _b.hreflang)) {
        console.log(`Alternate link not configured properly. Use the "seo.alternateLink" configuration property to set the base url and hreflang. Example: { baseUrl: 'https://www.mycasino.com/', hreflang: 'en-ca' }`);
        return;
      }
      this.baseUrl = config.alternateLink.baseUrl;
      this.hreflang = config.alternateLink.hreflang;
    });
  }
}
const alternateLink = new AlternateLinkService();

export { AlternateLinkService, alternateLink };
